/**
 * CaseManageSlice Call Logs Reducers
 * 
 * Reducers for managing call logs on cases.
 */

import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { CallLogView } from '../../types/caseManageTypes';
import { CaseManageSliceState } from '../state';

// =============================================================================
// CALL LOGS REDUCERS
// =============================================================================

/**
 * Add a new call log to the case
 */
export const addCallLog: CaseReducer<CaseManageSliceState, PayloadAction<Omit<CallLogView, 'callId'>>> = (
  state,
  action
) => {
  if (state.currentCase) {
    const newCallLog: CallLogView = {
      ...action.payload,
      callId: `temp_${Date.now()}`, // Temporary ID until saved
    };
    state.currentCase.callLogs.push(newCallLog);
    state.isEdited = true;
    if (!state.editedFields.includes('callLogs')) {
      state.editedFields.push('callLogs');
    }
  }
};

/**
 * Update an existing call log
 */
export const updateCallLog: CaseReducer<
  CaseManageSliceState,
  PayloadAction<{ callId: string; updates: Partial<CallLogView> }>
> = (state, action) => {
  if (state.currentCase) {
    const callIndex = state.currentCase.callLogs.findIndex(
      (call) => call.callId === action.payload.callId
    );
    if (callIndex !== -1) {
      state.currentCase.callLogs[callIndex] = {
        ...state.currentCase.callLogs[callIndex],
        ...action.payload.updates,
      };
      state.isEdited = true;
      if (!state.editedFields.includes('callLogs')) {
        state.editedFields.push('callLogs');
      }
    }
  }
};

/**
 * Remove a call log from the case
 */
export const removeCallLog: CaseReducer<CaseManageSliceState, PayloadAction<string>> = (
  state,
  action
) => {
  if (state.currentCase) {
    state.currentCase.callLogs = state.currentCase.callLogs.filter(
      (call) => call.callId !== action.payload
    );
    state.isEdited = true;
    if (!state.editedFields.includes('callLogs')) {
      state.editedFields.push('callLogs');
    }
  }
};
